<script>
import { generateNewDolu, updateDoluCategories, updateOneCategory, deleteOneCategory } from '@/services/MindMovieServices';
import { nextTick } from 'vue';

export default {
  props: ['propCategory'],
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),

      id: '',
      name: '',

      revealEditForm: false,
      editCategory: '',
    };
  },
  computed: {

  },
  methods: {
    async clickEdit() {
      this.revealEditForm = true;
      await nextTick();

      const c = document.getElementById(`input-edit-single-category-${this.id}`);
      if (c) { c.click(); }
    },
    async deleteCategory() {
      console.log('*** SingleCategory >> deleteWin() ***');

      // services call
      await deleteOneCategory(this.uId, this.token, this.id);
      // update ui
      const d = document.getElementById(`single-category-${this.id}`);
      if (d) {
        d.classList.add('d-none');
      }
      await nextTick();
      await updateDoluCategories(this.uId, this.token, generateNewDolu());
    },
    async updateCategory() {
      console.log('*** SingleCategory >> updateCategory() ***');

      // prep data
      const n = this.editCategory.trim();
      const updatedCategory = { name: n };

      // services call
      await updateOneCategory(this.uId, this.token, this.id, updatedCategory);

      // update ui
      // /* note: i purposely update only doluDbase, and not doluLocal, so that user will grab fresh MindMovie props the next time they load a MM page */
      await updateDoluCategories(this.uId, this.token, generateNewDolu());

      this.name = n;
      this.editCategory = n;
      this.revealEditForm = false;
    },

  },
  created() {
    this.id = this.propCategory.id;
    this.name = this.editCategory = this.propCategory.name;
  },
}
</script>

<template>
  <div
    :id="`single-category-${id}`"
    class="my-4 border rounded pa-3 bg-grey-lighten-3"
  >

    <div v-if="revealEditForm">
      <v-textarea v-model="editCategory"
                  :id="`input-edit-single-category-${id}`"
                  variant="outlined"
                  rows="1" auto-grow
                  label="Edit Category"
      ></v-textarea>
      <div class="d-flex justify-end">
        <v-btn @click.prevent="deleteCategory" class="mr-3">Delete</v-btn>
        <v-btn @click.prevent="updateCategory">Save</v-btn>
      </div>
    </div>

    <div v-else>
<!--      <p>{{id}}</p>-->
      <p>{{name}}</p>
      <p @click.prevent="clickEdit" class="text-right text-red-lighten-2 text-body-2 font-italic">edit</p>
    </div>

  </div>
</template>

<style scoped lang="scss">

</style>
